import script from "./BodyPhoneMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyPhoneMobile.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodyPhoneMobile.vue?vue&type=style&index=0&id=17d90005&module=bodyPhoneMobile&lang=css"
cssModules["bodyPhoneMobile"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__